;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "XjNvybC7Q4"							}), success: c, error: e});						}, cb  = function(section, $) {};					cb.bind($('section[data-section-id="XjNvybC7Q4"]').get(0))({						url: "https://library.layouthub.com/HUB/files/TWF5LS0yMDIw/NTkwNDU2ODky/twenty-twenty-summer/pages/SlvQ3GPz5IUBrjEM/hero/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "zdRb5pIEcM"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  var _this = jQuery(this),
      list  = _this.find('.lh-collection-list');

  // var item_selected = _this.find('.lh-item-title.active a').length ? _this.find('.lh-item-title.active a') : _this.find('.lh-item-title:first-child a');
  // item_selected.length && setActiveCate(item_selected);
  
  // _this.find('.lh-item-title a').click(function(){
  //   var __this = $(this);
  //   if(!__this.hasClass('active')){
  //     __this.parent().addClass('active').siblings('.active').removeClass('active');
  //     setActiveCate(__this);
  //   }
  // })
  // function setActiveCate($this) {
  //   var target = $this.data('value'),
  //       e_target = _this.find('.lh-item-collection[data-handle="'+target+'"]');
  //   if(e_target){
  //     e_target.addClass('active').siblings('.active').removeClass('active');
  //   }
  // }
  initRating();
  function initRating(){
  if(!document.querySelector('#lh-fake-review') && !window.SPR && (window.LAYOUTHUB_LIVE === true || window.location.protocol === 'blob:' ))
    {
      jQuery.get('https://productreviews.shopifycdn.com/assets/v4/spr.js', function(code) {
        var regex = new RegExp(['"','/','/'].join(''),'gm');
        code = code.replace(regex, '"https://').replace(/SPR\./g,'window.SPR.').replace('window.SPR=','window.SPR=window.SPR || ');
        code = code.replace('return r=t.remote_id.toString()','if(!t.remote_id)return 0;return r=t.remote_id.toString()');
        code = code.replace('return r.fn.serializeObject','return !r || !r.fb ? false : r.fn.serializeObject');
        var blob = new Blob([code], {
          type: "application/javascript"
        });
        var url = URL.createObjectURL(blob);
        var script = document.createElement("script");
        script.src = url;
        script.id = "lh-fake-review";
        script.type = "text/javascript";
        if (!window.SPR)
        document.head.append(script);
      })
    }
    else
    {
      if(window.SPR && window.SPR.$){
        window.SPR.loadjQueryExtentions(window.SPR.$);
        window.SPR.$(document).ready(function() {
            return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges()
        })
      }
    }
  }
 };						cb.bind($('section[data-section-id="zdRb5pIEcM"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="zdRb5pIEcM"]').get(0))({						url: "https://library.layouthub.com/HUB/files/TWF5LS0yMDIw/NTkwNDU2ODky/twenty-twenty-summer/pages/SlvQ3GPz5IUBrjEM/main_collection/",						settings: {}					}, jQuery);})(jQuery);;console.log('This page layout has been built by https://www.layouthub.com');